module.exports = __webpack_public_path__ + "assets/img/ocs-logo.b8e435f9.png";